import type { Catalog } from "../../en";
import { widgetHome } from "./widget-home";

/** Filipino: Widget Studio (mirrors en/deploy-knowledge/widget-studio.ts). */
export const widgetStudio: Catalog["deployKnowledge"]["widgetStudio"] = {
  title: "Widget Studio",
  subtitle: "{{agent}} sa {{domain}}",
  subtitleNoDomain: "{{agent}} · hindi pa naka-install",
  installed: "Naka-install",
  notInstalled: "Hindi naka-install",
  agentNotLive: "Hindi pa live ang agent",
  agentNotLiveHint: {
    draft: "Draft pa ang agent na ito, kaya hindi pa ma-load ang widget sa iyong site. I-publish ang agent para mag-live.",
    paused: "Naka-pause ang agent na ito, kaya hindi ma-load ang widget sa iyong site. Ituloy ang agent para mag-live.",
  },
  agentGate: {
    title: "Hindi pa live ang iyong widget",
    draft: {
      body: "Draft pa ang agent na ito, kaya hindi pa ma-load ang widget sa iyong site. I-publish ang agent para mag-live.",
      action: "I-publish ang agent",
      askAdmin: "Magpatulong sa isang admin para i-publish ito.",
      done: "Nai-publish ang agent · naglo-load na ang widget sa iyong site",
    },
    paused: {
      body: "Naka-pause ang agent na ito, kaya hindi ma-load ang widget sa iyong site. Ituloy ang agent para mag-live.",
      action: "Ituloy",
      askAdmin: "Magpatulong sa isang admin para ituloy ito.",
      done: "Naituloy ang agent · naglo-load na ang widget sa iyong site",
    },
  },
  publishChoice: {
    title: "I-publish ang widget at ang agent?",
    description: "Draft pa ang agent na ito, kaya hindi ma-load ang widget sa iyong site hangga't hindi rin nai-publish ang agent.",
    both: "I-publish ang pareho",
    widgetOnly: "Widget lang",
  },
  publishedBoth: "Nai-publish ang widget at ang agent · naglo-load na ang widget sa iyong site",
  publishedAgentDraft: "Nai-publish ang widget, pero draft pa rin ang agent · i-publish ang agent para ma-load ang widget sa iyong site",
  publishedAgentNeedsAdmin: "Nai-publish ang widget, pero draft pa rin ang agent · kailangang i-publish ng admin ang agent bago ma-load ang widget sa iyong site",
  tabsLabel: "Settings ng widget",
  tabs: {
    appearance: "Itsura",
    content: "Nilalaman",
    home: "Home",
    behavior: "Kilos",
    install: "I-install",
    security: "Seguridad",
  },
  saveDraft: "I-save ang draft",
  publish: "I-publish",
  draftSaved: "Na-save ang draft · i-publish para makita ng mga bisita",
  published: "Na-publish ang widget · makikita ng mga bisita ang bagong itsura sa loob ng 1 minuto",
  publishedVersion: "Na-publish ang v{{version}} · {{date}}",
  neverPublished: "Hindi pa na-publish",
  invalidForm: "May mga field na kailangang ayusin bago i-save.",
  notFoundTitle: "Wala na ang agent na ito",
  notFoundBody: "Maaaring na-delete na ito. Pumili ng ibang agent sa switcher.",
  appearance: {
    brandColor: "Kulay ng brand",
    brandHex: "Hex value",
    pickColor: "Pumili ng kulay ng brand",
    onBrand: "Teksto sa brand:",
    onBrandDark: "Madilim",
    onBrandLight: "Maliwanag",
    onBrandAuto: "(awtomatiko, ayon sa contrast)",
    ratio: "Contrast {{ratio}}:1",
    aaWarning: "Mas mababa sa 4.5:1 WCAG AA contrast ang teksto sa kulay na ito. Maaaring mahirap itong basahin.",
    tooLow: "Hindi umaabot sa 3:1 ang madilim o puting teksto sa kulay na ito. Pumili ng mas madilim o mas maliwanag na shade.",
    invalidHex: "Gumamit ng hex na kulay gaya ng #00aeef",
    presets: "Mga preset na kulay",
    presetNames: {
      brand: "Sky blue",
      maroon: "Maroon",
      forest: "Forest",
      navy: "Navy",
      amber: "Amber",
      ink: "Ink",
    },
    theme: "Tema",
    themeHint: "Sinusunod ng Auto ang setting ng device ng bisita.",
    themeLight: "Maliwanag",
    themeDark: "Madilim",
    themeAuto: "Auto",
    launcherStyle: "Istilo ng launcher",
    launcherIcon: "Bubble icon",
    launcherLabel: "May label",
    launcherLabelText: "Label ng launcher",
    launcherLabelPlaceholder: "hal. Magtanong",
    position: "Posisyon ng launcher",
    positionLeft: "Kaliwa sa ibaba",
    positionRight: "Kanan sa ibaba",
    radius: "Radius ng sulok",
    radiusSquare: "Parisukat",
    radiusRound: "Bilog",
    font: "Font",
    fontHint: "Ang uri ng letra ng launcher at chat panel sa site mo.",
    fontWebsite: "Sundan ang website mo",
    fontWebsiteHint: "Gagamitin ang font na naka-load na sa page mo. Walang dina-download.",
    fontGoogleHint: "Ilo-load ang {{font}} mula sa Google Fonts sa page mo. Kung naka-block ang Google Fonts sa site mo, system font na malinis ang makikita ng mga bisita.",
    fontDefaultHint: "Ang font na kasama na sa widget. Walang dina-download.",
    fontSample: "Aa Halimbawang sagot",
    headerTitle: "Pamagat ng header",
    headerSubtitle: "Subtitle ng header",
    avatar: "Avatar",
    upload: "Mag-upload",
    uploading: "Nag-a-upload…",
    useAgentAvatar: "Gamitin ang avatar ng agent",
    avatarHint: "PNG, JPEG o WebP · hanggang 2 MB",
    avatarUploaded: "Na-upload ang {{name}}",
    avatarReset: "Ginagamit ang avatar ng agent",
    avatarInvalid: "Gumamit ng PNG, JPEG o WebP na larawan na hanggang 2 MB.",
    avatarFailed: "Hindi na-upload ang larawan. Subukan muli.",
    avatarAlt: "Avatar ng widget",
    iconUpload: {
      title: "Icon ng launcher",
      hint: "PNG, JPEG o WebP · hanggang 2 MB · mas maganda ang parisukat na larawan",
      upload: "Mag-upload ng icon ng launcher",
      remove: "Alisin ang icon",
      previewLabel: "Preview ng icon ng launcher",
      usingCustom: "Gamit ang na-upload mong icon.",
      usingDefault: "Gamit ang default na chat bubble.",
      checking: "Sinusuri ang {{name}}…",
      uploading: "Ina-upload ang {{name}}…",
      ready: "Handa na ang {{name}}. I-save ang mga pagbabago para magamit ito.",
      removed: "Naalis ang icon. I-save ang mga pagbabago para bumalik sa chat bubble.",
      retry: "Subukan muli",
      wrongType: "Hindi PNG, JPEG o WebP na larawan ang {{name}}. Hindi suportado ang SVG at iba pang format.",
      tooBig: "{{size}} MB ang {{name}}. Gumamit ng larawang hanggang 2 MB.",
      empty: "Walang laman ang {{name}}. Pumili ng ibang larawan.",
      tooSmall: "{{width}} × {{height}} px ang {{name}}. Gumamit ng larawang hindi bababa sa {{min}} × {{min}} px.",
      tooLarge: "{{width}} × {{height}} px ang {{name}}. Gumamit ng larawang hanggang {{max}} × {{max}} px.",
      unreadable: "Hindi mabasa ang {{name}}. Maaaring sira ito. Pumili ng ibang larawan.",
      failed: "Hindi na-upload ang {{name}}. Tingnan ang koneksyon mo at subukan muli.",
    },
    branding: "Ipakita ang “Powered by {{product}}”",
    brandingLocked: "Maaalis sa Pro.",
    brandingIncluded: "Pinapayagan ng plano mo na itago ito.",
    comparePlans: "Ikumpara ang mga plano",
    brandingFeature: "Pag-alis ng “Powered by {{product}}”",
    brandingSwitch: "Powered by {{product}}",
    brandingSwitchLocked: "Powered by {{product}} (mag-upgrade para alisin)",
  },
  content: {
    welcome: "Mensahe ng pagbati",
    starters: "Mga panimulang tanong",
    startersMax: "Hanggang {{count}}",
    starterPlaceholder: "Panimulang tanong {{n}}",
    starterTip: "Tip: nasa Analytics ang mga pinakamadalas itanong —",
    analytics: "Analytics",
    placeholder: "Placeholder ng input",
    privacyNotice: "Privacy notice",
    privacyUrl: "Link ng privacy notice",
    privacyUrlInvalid: "Gumamit ng buong https:// na link",
    charLimit: "Limitasyon ng karakter",
    charLimitRange: "Mula {{min}} hanggang {{max}}",
    attachments: "Mga attachment",
    attachmentsOff: "Naka-off",
    attachmentsImages: "Larawan lamang",
    attachmentsImagesPdf: "Larawan + PDF",
  },
  behavior: {
    autoOpen: "Kusang buksan",
    autoOpenHint: "Sa unang pagbisita lamang, desktop lamang.",
    after: "Pagkalipas ng",
    seconds: "segundo",
    autoOpenDelay: "Segundo bago buksan",
    proactive: "Proactive na message bubble",
    proactiveHint: "Maikling paalala sa itaas ng launcher. Isara ang preview widget para makita ito.",
    proactiveMessage: "Mensahe",
    proactiveDelay: "Ipakita pagkalipas ng (segundo)",
    proactivePages: "Ipakita sa mga page na tugma sa",
    proactivePagesHint: "Pinaghihiwalay ng kuwit, hal. /pricing, /contact/*. Walang laman = lahat ng page.",
    showOnMobile: "Ipakita sa mobile",
    leadCapture: "Kumuha ng lead bago mag-chat",
    leadOff: "Naka-off",
    leadOptional: "Opsyonal",
    leadRequired: "Kailangan",
    leadHintOff: "Agad makakapag-chat ang mga bisita.",
    leadHintOptional: "Hinihingi ang pangalan at mobile pero puwedeng laktawan.",
    leadHintRequired: "Ibinibigay ng bisita ang pangalan at mobile bago ang unang mensahe.",
    outOfHours: "Labas sa oras ng opisina",
    outOfHoursCallback: "Patuloy na sumagot · mag-alok ng callback sa halip na live handoff",
    outOfHoursHide: "Patuloy na sumagot · itago ang “Kausapin ang staff”",
    outOfHoursOffline: "Offline na mensahe lamang",
    sound: "Tunog ng abiso",
    soundHint: "Mahinang tunog sa bagong sagot",
    remember: "Tandaan ang usapan",
    rememberHint: "Babalik ang bisita sa huling chat sa parehong browser",
    rememberDays: "Ilang araw tatandaan",
  },
  install: {
    detected: "Natagpuan sa {{origin}}",
    lastSeen: "Huling nakita {{when}} · {{count}} site",
    notDetected: "Hindi pa natatagpuan",
    notDetectedHint: "Idagdag ang snippet sa site mo, saka i-check muli. Maaaring abutin ng isang minuto pagkatapos ng unang pag-load.",
    recheck: "I-check muli",
    rechecked: "Na-refresh ang status ng install",
    methods: "Paraan ng pag-install",
    html: "HTML",
    react: "React / Next.js",
    wordpress: "WordPress",
    portal: "Portal / LMS",
    identity: "Mga naka-sign-in na bisita",
    mobile: "Mobile app",
    iframe: "Iframe",
    iframeIntro: "Ipakita ang chat sa loob ng sarili mong page. Binubuksan ng frame ang launch endpoint mo, na sine-sign in ang customer at dinadala sila sa chat, kaya hindi na sila makakakita ng sign-in page.",
    iframeAllowed_one: "{{count}} site ang puwedeng magpakita ng chat",
    iframeAllowed_other: "{{count}} site ang puwedeng magpakita ng chat",
    iframeManage: "Pamahalaan ang mga pinapayagang site",
    iframeNotes: {
      title: "Bago mo i-paste",
      src: "Ituro ang src sa endpoint sa sarili mong site na humihingi sa Sagot ng launch link (mode embed, ang address ng page mo bilang parent_origin) at sumasagot ng 303 papunta rito. Placeholder lang ang /sagot/launch hangga't hindi mo pa nirerehistro ang mint URL mo.",
      csp: "Kung may Content-Security-Policy ang site mo, idagdag ang frame-src {{origin}}.",
      keep: "Huwag ilagay ang frame sa mga page ng bayad at deposito.",
      reload: "Ang pag-reload, o session na natapos na, ay babalik sa endpoint mo at magpapatuloy na naka-sign in.",
    },
    iframeNeedsTitle: "Ipakita ang chat sa loob ng sarili mong page",
    iframeNeedsBody: "Lalabas ang Iframe kapag may site mo nang pinapayagang magpakita ng chat. Idagdag ang eksaktong address ng site, tulad ng https://www.example.com, sa Settings > Secure launch.",
    iframeNeedsAction: "Magdagdag ng pinapayagang site",
    htmlHint: "I-paste bago ang </body> sa bawat page.",
    reactHint: "I-paste ang component na ito sa app mo at i-render nang isang beses sa root layout. Iisang script ang nilo-load nito, kaya walang kailangang i-install. Ipasa ang signedIn at name para sa naka-sign in na user; mala-logout din sila sa assistant kapag nag-sign out.",
    agentId: "Agent ID",
    snippetLabel: "Snippet para sa {{method}}",
    guide: "Gabay sa identity verification",
    emailDev: "I-email ang instructions sa iyong developer",
    snippetsError: "Hindi ma-load ang mga install snippet.",
    identityIntro: "Hayaang makipag-chat bilang sarili nila ang mga naka-sign-in sa site mo, para mabasa nila ang puwedeng basahin ng account nila. Pipirmahan ng server mo ang panandaliang token; kukunin ito ng widget para sa iyo.",
    identityClient: "Sa page mo",
    identityServer: "Sa server mo",
    identityServerHint: "Magdagdag ng endpoint sa /sagot-token na sasagot lang sa mga bisitang naka-sign-in sa site mo.",
    identityLang: "Wika ng server",
    identityLangs: { node: "Node.js", php: "PHP", python: "Python" },
    identityNotes: {
      title: "Paano ito gumagana",
      secret: "Nananatili ang secret key sa environment ng server mo (SAGOT_IDENTITY_SECRET). Huwag itong ilagay sa page o sa code na mababasa ng mga bisita.",
      ttl: "10 minuto ang tagal ng token. 15 minuto ang pinakamahaba na puwedeng itagal ng token.",
      refresh: "Kumukuha ang widget ng token pag-load nito, nire-refresh ito isang minuto bago mag-expire, at isa pang beses kung 401 ang sagot ng server.",
      logout: "Tawagin ang logout kapag nag-sign out ang bisita sa site mo: kakalimutan nito ang bisita at guest na ang susunod na chat.",
    },
    mobileIntro: "Idagdag ang assistant sa sarili mong iOS o Android app. Walang kailangang i-download sa amin: bubuksan ng app mo ang chat page ng assistant sa isang WebView, at isasama mo ito sa app mo.",
    mobileFramework: "Framework",
    mobileFrameworks: { react_native: "React Native", flutter: "Flutter", ios: "iOS (Swift)", android: "Android (Kotlin)", maui: ".NET MAUI", capacitor: "Capacitor / Ionic", ios_launch: "iOS may sign-in (Swift)", android_launch: "Android may sign-in (Kotlin)" },
    mobileNotes: {
      title: "Mabuting malaman",
      channel: "Ang Web app channel ang nagse-serve ng chat page. Panatilihin itong naka-on sa Channels.",
      same: "Iisang assistant ito: gumagana ang mga sagot na may sources, handoff sa team mo at mga usapan sa Inbox gaya sa website mo.",
      updates: "Palitan ang kaalaman ng assistant sa Sagot at agad magbabago ang sagot ng app. Hindi mo kailangang maglabas ng bagong bersyon ng app.",
      guests: "Guest ang mga bisita at puwede nilang kumpirmahin ang email gamit ang code sa loob ng chat. Para sa script widget sa mga website ang identity token ng mga naka-sign-in.",
      launch: {
        backend: "Ang mga tab na may sign-in ay nagbubukas ng chat sa browser view ng system (Safari view o Custom Tabs), hindi sa WebView o iframe. Ang app ay humihingi ng link sa sarili ninyong backend; nasa server ninyo ang Sagot key.",
        browser: "Tinatawag ng backend ninyo ang POST /api/v1/launch-sessions at ibinabalik ang launch_url. Buksan agad: minsan lang magagamit ang code na nasa likod ng #.",
        push: "Ipadala ang context ng customer gamit ang POST /api/v1/customers/context, o mag-subscribe sa message.created: dala ng event ang customer_ref para maitugma ng backend ninyo ang sagot sa naka-sign-in na customer.",
      },
    },
  },
  emailDialog: {
    title: "I-email ang install instructions",
    email: "Email ng developer",
    emailInvalid: "Maglagay ng tamang email address",
    note: "Tala (opsyonal)",
    includes: "Kasama ang snippet, ang Agent ID at link sa gabay sa identity verification. Hindi kasama ang secret key.",
    send: "Ipadala",
    sent: "Naipadala ang instructions kay {{email}}",
  },
  security: {
    allowedDomains: "Mga pinapayagang domain",
    allowedDomainsHint: "Sa mga domain na ito lamang naglo-load ang widget (kasama ang mga subpath). Sakop din ng example.com ang www.example.com; gamitin ang *.example.com para sa lahat ng subdomain.",
    domainPlaceholder: "hal. help.example.com",
    localHint: "Nagte-test sa sarili ninyong computer? Idagdag ang localhost:3000 (isama ang port).",
    add: "Idagdag",
    remove: "Alisin ang {{domain}}",
    domainInvalid: "Maglagay ng domain gaya ng help.example.com, *.example.com o localhost:3000.",
    domainDuplicate: "Nasa listahan na ang {{domain}}.",
    domainsFull: "Hanggang {{max}} domain lang ang maidaragdag. Mag-alis ng isa para makapagdagdag.",
    domainsCount: "{{count}} sa {{max}}",
    domainAdded: "Naidagdag ang {{domain}}",
    domainRemoved: "Naalis ang {{domain}}",
    noDomains: "Wala pang domain — hindi maglo-load ang widget hangga't walang idinadagdag.",
    identity: "Identity verification",
    identityHint: "Kailangan para sa mga sagot na pang-miyembro lamang at mga aksyong kailangang malaman kung sino ang nagtatanong.",
    step1: "Kapag nag-sign in ang user sa site mo, pipirmahan ng server mo ang JWT (HS256) gamit ang user ID, role at ang secret sa ibaba.",
    step2: "Ipapasa ito ng page mo sa {{product}}('identify', { token }).",
    step3: "Bine-verify ng {{product}} ang pirma — hindi mapepeke ng user kung sino sila.",
    secret: "Secret key",
    secretConfigured: "May secret key na. Isang beses lang ito ipinapakita, pagka-generate.",
    secretMissing: "Wala pang secret key. Mag-generate para simulang i-verify ang mga user.",
    secretHint: "Itago ito sa server mo lamang.",
    previousExpires: "Gumagana pa ang dating key hanggang {{date}}.",
    rotate: "I-rotate ang key",
    generate: "Mag-generate ng key",
    sample: "Halimbawa ng pag-sign",
    rateVisitor: "Mensahe bawat bisita / oras",
    rateIp: "Bagong chat bawat IP / araw",
    rateVisitorHint: "Ipinapatupad sa bawat mensahe. Kapag lumampas, hihilingin sa bisita na maghintay sandali.",
    rateIpHint: "Binibilang ang mga usapang nasimulan mula sa iisang network. Iisang connection ang gamit ng mga paaralan at opisina, kaya isama ang lahat ng gumagamit nito.",
    blocked: "Mga naka-block na IP",
    blockedHint: "Isang IP o CIDR range bawat linya. Tala ang teksto pagkatapos ng #.",
    blockedInvalid: "Hindi IP address o CIDR range ang linya {{line}}",
    save: "I-save ang security settings",
    saved: "Na-save ang security settings",
  },
  rotateDialog: {
    title: "I-rotate ang secret key?",
    titleGenerate: "Mag-generate ng secret key?",
    warning: "Gumagana pa ang kasalukuyang key nang 24 oras para ma-update mo ang server. Pagkatapos noon, tatanggihan ang mga token na pinirmahan ng lumang key.",
    confirm: "I-rotate ang key",
    confirmGenerate: "Mag-generate ng key",
    rotated: "Bagong key na-generate · mag-e-expire ang luma sa loob ng 24 oras",
    newTitle: "Ang bago mong secret key",
    newBody: "Kopyahin na ito at itago sa server mo. Para sa seguridad, hindi na ito ipapakita muli.",
    secretLabel: "Bagong secret key",
    done: "Naitago ko na",
  },
  preview: {
    live: "Live preview",
    liveHint: "· hindi mapa-publish ang mga pagbabago hangga't hindi mo sine-save",
    device: "Device ng preview",
    desktop: "Desktop",
    mobile: "Mobile",
    openDemo: "Buksan ang demo",
    openDemoLabel: "Buksan ang demo sa bagong tab",
    footer: "Sample na sagot ang nasa preview. Subukan ang totoong assistant sa",
    playground: "Playground",
    conversation: "Halimbawang usapan",
    region: "Preview ng widget",
    siteName: "Iyong website",
    siteHeadline: "Dito lalabas ang nilalaman ng page mo",
    siteBody: "Lulutang ang widget sa ibabaw ng site mo nang ganito.",
    sampleQuestion: "Ano ang oras ng opisina ninyo?",
    sampleAnswer: "Galing sa iyong knowledge sources ang mga sagot, may citation — subukan ang totoong tanong sa Playground.",
    sampleSource: "Iyong knowledge source",
    toggle: "Buksan o isara ang preview widget",
    close: "Isara ang preview widget",
    poweredBy: "Pinapagana ng {{product}}",
    send: "Ipadala",
    defaultTitle: "Makipag-chat sa amin",
  },
  home: widgetHome,
};
